import { render } from "./ControlsExplained.vue?vue&type=template&id=68c4cb30&scoped=true"
import script from "./ControlsExplained.vue?vue&type=script&lang=js"
export * from "./ControlsExplained.vue?vue&type=script&lang=js"

import "./ControlsExplained.vue?vue&type=style&index=0&id=68c4cb30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c4cb30"]])

export default __exports__